/* Constants for Magni Sign-in/out Application */

// Available locations
const LOCATIONS = [
  "Birmingham",
  "Troy",
  "Detroit",
  "Shelby",
  "Madison Heights",
  "Ferndale",
  "Kentucky",
  "Portland",
  "Sales",
  "Out of Office"
];

// Location icons
// Location icons
const LOCATION_ICONS: Record<string, string> = {
  "Birmingham": "🏢",
  "Troy": "🏛️",
  "Detroit": "🏙️",
  "Shelby": "🏭",
  "Madison Heights": "🏢",
  "Ferndale": "🏭",
  "Kentucky": "🏛️",
  "Portland": "🏛️",
  "Sales": "💼",
  "Out of Office": "🏡"
};

// Color palette for avatars and UI elements
const COLOR_PALETTE = [
  { bg: 'var(--apple-light-blue)', text: 'var(--apple-blue)', initial:  'var(--apple-blue)'},
  { bg: 'var(--apple-light-green)', text: 'var(--apple-green)',initial:  'var(--apple-green)' },
  { bg: 'var(--apple-light-red)', text: 'var(--apple-red)',initial:  'var(--apple-red)' },
  { bg: 'var(--apple-light-orange)', text: 'var(--apple-orange)',initial:  'var(--apple-orange)' },
  { bg: 'var(--apple-light-purple)', text: 'var(--apple-purple)',initial:  'var(--apple-purple)' },
  { bg: 'var(--apple-light-pink)', text: 'var(--apple-pink)',initial:  'var(--apple-pink)' }
];

const availableLocations = Object.keys(LOCATION_ICONS);
// Export all constants
export {
  LOCATIONS,
  LOCATION_ICONS,
  COLOR_PALETTE,
  availableLocations

};